// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bandeja-enviados {
  padding: 24px;
  max-width: 1500px;
  margin: 0 auto;
  animation: fadeIn 0.5s ease;
}

.enviados-header {
  margin-bottom: 28px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--border);
}

.enviados-header h2 {
  color: var(--gray-900);
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 8px;
  letter-spacing: -0.5px;
}

.enviados-header .subtitle {
  color: var(--text-muted);
  font-size: 14px;
}

.stat-estado {
  border-left: 4px solid var(--gray-400);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  transition: var(--transition);
}

.stat-estado:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-md);
}

.stat-estado h3 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0;
  text-transform: none;
  letter-spacing: 0;
  font-size: 13px;
}

.estado-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  animation: pulse 2s ease infinite;
}

.filtros-container {
  background: var(--bg-card);
  padding: 24px;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  margin-bottom: 24px;
  border: 1px solid var(--border);
}

.filtros-container h3 {
  margin-bottom: 20px;
  color: var(--gray-900);
  font-size: 18px;
  font-weight: 700;
}

.filtros-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.filtros-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.tabla-container {
  background: var(--bg-card);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  overflow-x: auto;
  border: 1px solid var(--border);
  transition: var(--transition);
}

.tabla-container:hover {
  box-shadow: var(--shadow-md);
}

.tabla-container h3 {
  margin: 0;
  padding: 16px 20px;
  color: var(--gray-800);
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid var(--border);
  background: var(--gray-50);
}

@media (max-width: 768px) {
  .enviados-header h2 {
    font-size: 24px;
  }

  .filtros-grid {
    grid-template-columns: 1fr;
  }

  .filtros-actions {
    flex-direction: column;
  }

  .filtros-actions .btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/BandejaEnviados.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".bandeja-enviados {\n  padding: 24px;\n  max-width: 1500px;\n  margin: 0 auto;\n  animation: fadeIn 0.5s ease;\n}\n\n.enviados-header {\n  margin-bottom: 28px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid var(--border);\n}\n\n.enviados-header h2 {\n  color: var(--gray-900);\n  font-size: 28px;\n  font-weight: 800;\n  margin-bottom: 8px;\n  letter-spacing: -0.5px;\n}\n\n.enviados-header .subtitle {\n  color: var(--text-muted);\n  font-size: 14px;\n}\n\n.stat-estado {\n  border-left: 4px solid var(--gray-400);\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  transition: var(--transition);\n}\n\n.stat-estado:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-md);\n}\n\n.stat-estado h3 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 0;\n  text-transform: none;\n  letter-spacing: 0;\n  font-size: 13px;\n}\n\n.estado-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: inline-block;\n  animation: pulse 2s ease infinite;\n}\n\n.filtros-container {\n  background: var(--bg-card);\n  padding: 24px;\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  margin-bottom: 24px;\n  border: 1px solid var(--border);\n}\n\n.filtros-container h3 {\n  margin-bottom: 20px;\n  color: var(--gray-900);\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.filtros-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.filtros-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.tabla-container {\n  background: var(--bg-card);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  overflow-x: auto;\n  border: 1px solid var(--border);\n  transition: var(--transition);\n}\n\n.tabla-container:hover {\n  box-shadow: var(--shadow-md);\n}\n\n.tabla-container h3 {\n  margin: 0;\n  padding: 16px 20px;\n  color: var(--gray-800);\n  font-size: 16px;\n  font-weight: 600;\n  border-bottom: 1px solid var(--border);\n  background: var(--gray-50);\n}\n\n@media (max-width: 768px) {\n  .enviados-header h2 {\n    font-size: 24px;\n  }\n\n  .filtros-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .filtros-actions {\n    flex-direction: column;\n  }\n\n  .filtros-actions .btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
